import * as v from "valibot";

/** IngressClass annotations：键值对（如 meta.helm.sh/release-namespace） */
const annotationsSchema = v.optional(v.record(v.string(), v.string()));

/** IngressClass item schema：集群级资源，含 controller 与 helm 注解供解析 Controller Service */
export const IngressClassItemSchema = v.object({
  metadata: v.object({
    name: v.optional(v.string()),
    annotations: annotationsSchema,
  }),
  spec: v.object({
    controller: v.optional(v.string()),
  }),
});
export type IngressClassItem = v.InferOutput<typeof IngressClassItemSchema>;

/** Controller Service 的 LB ingress 条目：{ ip } 或 { hostname } */
const lbIngressEntrySchema = v.object({
  ip: v.optional(v.string()),
  hostname: v.optional(v.string()),
});

/**
 * Controller Service item schema：type=LoadBalancer 的 Service，
 * Controller LB IP 从 status.loadBalancer.ingress[].ip 读取。
 */
export const ServiceItemSchema = v.object({
  metadata: v.object({
    name: v.optional(v.string()),
    namespace: v.optional(v.string()),
  }),
  status: v.optional(
    v.object({
      loadBalancer: v.optional(
        v.object({
          ingress: v.optional(v.array(lbIngressEntrySchema)),
        }),
      ),
    }),
  ),
});
export type ServiceItem = v.InferOutput<typeof ServiceItemSchema>;
